import { render, staticRenderFns } from "./sfc-gdpr-banner.vue?vue&type=template&id=38508c48&lang=pug&"
import script from "./sfc-gdpr-banner.vue?vue&type=script&lang=js&"
export * from "./sfc-gdpr-banner.vue?vue&type=script&lang=js&"
import style0 from "./sfc-gdpr-banner.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports